export default function Arrangements() {
  return <h1>Arrangements</h1>;
}